import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("uknri_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => localStorage.removeItem("uknri_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("uknri_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("uknri_token");
    setUser(null);
  };
  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data.user); } catch { /* noop */ }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}
